module.exports = __webpack_public_path__ + "static/media/viewIcon.c469126e.svg";